import { Component, DestroyRef, OnInit, inject, input } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Store } from '@ngxs/store';
import {
	IFeatureCareers,
	IPopuplarCategories
} from 'src/app/store/landing/landing-interface';
import { LandingState } from 'src/app/store/landing/landing.state';
import { LandingActions } from 'src/app/store/landing/landing.actions';
import { AppCommon } from 'src/app/shared/app.common';
import { SITE_DATA } from 'src/app/productization/default.constant';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { RouterLink } from '@angular/router';
import { NgClass, SlicePipe } from '@angular/common';

@Component({
    selector: 'app-categories',
    templateUrl: './categories.component.html',
    styleUrls: ['./categories.component.scss'],
    imports: [NzGridModule, RouterLink, NgClass, SlicePipe]
})
export class CategoriesComponent implements OnInit {
	private store = inject(Store);
	private destroyRef = inject(DestroyRef);

	readonly countryOrigin = input<string | null>(null);
	private readonly jobLandingResult = this.store.select<any>(LandingState.getLandingData);
	public popularCategories: IPopuplarCategories[] = [];

	public siteData = SITE_DATA;

	ngOnInit(): void {
		this.jobLandingResult?.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data) => {
			this.popularCategories = data.popuplarCategories;
		});

		this.store.dispatch(new LandingActions.GetTopCategory());
	}

	public getIconCategory(category: string) {
		return AppCommon.getIconCategory(category);
	}
}
